module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/85a7793e786650bb42e91693642f26c9.png";